import TeamGraph from './TeamGraph.vue';
export default TeamGraph;
